import React from 'react';
/* eslint-disable react/prefer-stateless-function */
import { Navigate, NavigateFunction } from 'react-router-dom';
import { Box, TextField, Button, Typography, FormControl } from '@mui/material';

import { withRouter } from '../../common/hooks/withParams';
import { connect } from 'react-redux';
import { addError } from '../../actions/notifications';
import PasswordTextField from '../common/PasswordTextField';
import { ReduxState } from '../../reducers';
import { login } from '../../actions/auth';
const logo = require('../../assets/login.png')

export interface LoginState {
  email: string;
  password: string;
  error?: string;
  loading: boolean;
}
export interface LoginProps {
  authenticated: boolean;
  initialized: boolean;
  navigate: NavigateFunction;
  login: (email: string, password: string) => Promise<any>;
  addError: (error: string) => void;
}

class LoginComponentMain extends React.Component<LoginProps, LoginState> {
  playerPollingId: any

  constructor(props: any) {
    super(props)
    this.state = {
      email: '',
      password: '',
      loading: false,
    }
  }

  onUserNameChanged = (e: any) => {
    this.setState({ email: e.target.value })
  }

  onPasswordChanged = (e: any) => {
    this.setState({ password: e.target.value })
  }

  onLogin = async() => {
    const { email, password } = this.state
    if(!email || !password) {
      this.setState({ error: 'Please enter an email and password'})

      return
    }

    this.setState({ error: undefined, loading: true })

    try {
      await this.props.login(email.trim(), password.trim())
      this.props.navigate('/')
    } catch(e: any) {
      this.setState({ error: `${e}` })
      this.props.addError(`${e}`)
    } 
    this.setState({ loading: false })
  }

  render = () => {
    const { email, password, error, loading } = this.state
    const { authenticated, initialized } = this.props

    if (authenticated && initialized) {
      return <Navigate to="/" />;
    }

    if(!initialized) {
      return null;
    }
    return (
      <Box sx={{ p: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ height: '100vh', maxWidth: '35rem', p: 6, display: 'flex', flexDirection: 'column', gap: 6 }}>
             <Typography variant="h4" sx={{ textAlign: 'center' }}>Admin Login</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControl variant="outlined" fullWidth>
                <TextField
                  variant="outlined"
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.onUserNameChanged}
                  label="Email address"
                />
              </FormControl>
              <FormControl variant="outlined" fullWidth>
                <PasswordTextField
                  variant="outlined"
                  type="password"
                  name="password"
                  value={password}
                  onChange={this.onPasswordChanged}
                  label="Password"
                />
              </FormControl>
                <Button
                  sx={{
                    flex: 1,
                    mt: 2,
                    py: 2,
                    backgroundColor: 'blue.600',
                    '&:hover': { backgroundColor: 'blue.700' },
                    '&:active': { backgroundColor: 'blue.800' }
                  }}
                  variant="outlined"
                  disabled={loading}
                  onClick={this.onLogin}
                >
                  Sign in
                </Button>
              {error && (
                <Typography sx={{ mt: 5, color: 'red.700' }}>{error}</Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    );
    
  }
}

export const mapStateToProps = ({ auth }: ReduxState) => {
  const { initialized, authenticated } = auth
  return {
    initialized,
    authenticated,
  }

}


export const LoginComponent = connect(mapStateToProps, { login, addError })(withRouter(LoginComponentMain))